export const PURCHASE_ORDER = 'PurchaseOrder';
export const PurchaseOrderStatusValues = [
    'draft',
    'confirmed',
    'partially-received',
    'received',
    'cancelled',
];
export const PURCHASE_ORDER_STATUS_LABELS = {
    draft: 'Rascunho',
    confirmed: 'Confirmado',
    'partially-received': 'Parcialmente recebido',
    received: 'Recebido',
    cancelled: 'Cancelado',
};
//# sourceMappingURL=purchase-order.js.map